export default __webpack_public_path__ + "static/media/sue.dbc62ddd.png";